import React from 'react';
import App from '@app';
import { Body, PageHeader } from '@components';
import Processos from './TableProcessos';

export default function ProcessoWeb() {
  return (
    <App>
      <Body>
        <PageHeader title='Processos Web'>
          <Processos />
        </PageHeader>
      </Body>
    </App>
  );
}
